import { Skeleton } from '@mui/material';
import { useState, useEffect } from 'react';
import { BannerSectionWrapper, BannerSectionContent, BannerSectionText, BannerSectionButton, BannerButtonText } from './styles/components';
import { Box } from '@mui/material';
import { Plan, usePlanContext } from './context/planContext';
import { handleSignUp } from './utils';
import { useLocation, useNavigate } from "react-router-dom";
import { PROMO_CODE } from '../../config';

export default function BannerSection() {
  const { bestValuePlan, plans, selectedPlan, zipCode, utility, } = usePlanContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  // const [bestValuePlan, setBestValuePlan] = useState<Plan | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  // Find and store the best value (lowest price) plan
  // useEffect(() => {
  //   if (!plans || plans.length === 0) return;
    
  //   const lowestPriceIndex = plans.reduce(
  //     (minIndex, plan, currentIndex, array) => {
  //       return parseFloat(plan.price) < parseFloat(array[minIndex]?.price || "999") ? currentIndex : minIndex;
  //     }, 0
  //   );

  //   const reorderedPlans = [...plans];
  //   if (lowestPriceIndex !== 1 && plans.length > 1) {
  //     const bestPlan = reorderedPlans.splice(lowestPriceIndex, 1)[0];
  //     reorderedPlans.splice(1, 0, bestPlan);
  //   }

  //   setBestValuePlan(reorderedPlans[1] || reorderedPlans[0]);
  // }, [plans]);

  return (
    <BannerSectionWrapper>
        {loading ? (
          <Box sx={{ 
            display: 'flex',
            maxWidth: '1200px',
            alignItems: 'flex-end',
            gap: '40px',
            flex: '1 0 0',
            width: '100%',
          }}>
            <Box sx={{ flex: '1 0 0' }}>
              <Skeleton variant="text" width="100%" height={50} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="90%" height={50} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="70%" height={50} />
            </Box>
            <Skeleton variant="rounded" width={280} height={56} sx={{ borderRadius: '6px' }} />
          </Box>
        ) : (
          <BannerSectionContent>
            <BannerSectionText>
              Join over 2 million satisfied customers and start saving on your electricity bill today. Sign up with Constellation.
            </BannerSectionText>
            
            <BannerSectionButton 
              variant="contained"
              disabled={!bestValuePlan}
            >
              <BannerButtonText 
                onClick={() => {
                  localStorage.setItem("selectProduct", JSON.stringify(bestValuePlan));
                  localStorage.setItem("utility", JSON.stringify(utility));
                  localStorage.setItem("promoCode", PROMO_CODE);
                  handleSignUp(bestValuePlan as Plan, zipCode, utility, navigate, location);}}
              >
                Sign up with Constellation
              </BannerButtonText>
            </BannerSectionButton>
          </BannerSectionContent>
        )}
    </BannerSectionWrapper>
  );
}
